<template>
	<div class="ended">
	<notifications></notifications>
	  <div class="text-right px-4 pt-3 pb-0">
		<button class="btn btn-primary" @click="homeHandler"  style="z-index:9999">Home</button>
	  </div>
	  <!-- Header -->
	  <div class="ended" v-if="is_success !== null">
			<div class="header mt--5 h-100 d-flex justify-content-center align-items-center">
			<b-container>
				<div class="header-body text-center mb-7">
				<b-row class="justify-content-center" v-if="is_success === 1">
					<b-col class="px-5">
					<h1 class="display-3 text-im2u font-weight-bold mb-2 text-success d-flex justify-content-center align-items-center">
						<span class="font-weight-bold mr-3">Upgrade Successful</span>
						<b-icon	 icon="check-circle-fill"></b-icon>
					</h1>
					<p class="text-im2u mb-4">Yay! Your subscription was upgraded.</p>
					</b-col>
				</b-row>
				<b-row class="justify-content-center" v-if="is_success === 0">
					<b-col class="px-5">
					<h1 class="display-3 text-im2u font-weight-bold mb-2 text-danger d-flex justify-content-center align-items-center">
						<span class="font-weight-bold mr-3">Upgrade Failed</span>
						<b-icon	 icon="x-circle-fill"></b-icon>
					</h1>
					<p class="text-im2u mb-4">Oops! Failed to upgrade subscription. Please try again.</p>
					<button @click="tryAgainHandler" class="btn btn-primary" style="z-index:9999">Try Again</button>
					</b-col>
				</b-row>
				</div>
			</b-container>
			<div class="separator separator-bottom separator-skew zindex-100">
				<svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
				</svg>
			</div>
			</div>
	  </div>
	  <div v-else>
		  <div v-if="packages.length > 0">
			<!-- Header -->
			<div class="pt-5 pb-5 pb-md-6 mb-8">
				<b-container>
					<b-row class="justify-content-center">
						<b-col cols="12" class="text-center">
							<h1>Choose the best plan for your business</h1>
						</b-col>
					</b-row>
				</b-container>
			</div>
			<!-- Page content -->
			<b-container class="mt--8 pb-5">
				<b-row class="justify-content-center">
					<b-col cols="12">
						<b-card-group class="pricing flex-column flex-md-row mb-3 mx-auto">
							<!-- Basic Package -->
							<b-card
								v-for="(pkg, index) in packages"
								:key="index"
								:class="pkg.package_type === 'Corporate' ? 'zoom-in bg-gradient-primary' : ''"
								:footer-class="pkg.package_type === 'Corporate' ? 'bg-gradient-primary' : ''"
								header-class="bg-transparent"
								body-class="px-5"
								class="card-pricing border-0 text-center mb-4 mx-auto"
								style="max-width:600px"
							>
								<h4
									slot="header"
									class="text-uppercase ls-1 text-primary py-3 mb-0"
									:class="pkg.package_type === 'Corporate' ? 'text-white' : ''"
								>
									{{ pkg.package_type }} Package
								</h4>
	
								<div v-if="pkg.price === 0" class="display-2">FREE</div>
								<div v-else class="display-2" :class="pkg.package_type === 'Corporate' ? 'text-white' : ''">RM {{ pkg.price | moneyFormatter }}</div>
	
								<span v-if="pkg.price !== 0" :class="pkg.package_type === 'Corporate' ? 'text-white' : 'text-muted'">per Year</span>
								<ul class="list-unstyled my-4">
	
									<div v-for="(details, key) in pkg.package_details" :key="key">
										<li>
											<div>
												<i class="fas fa-check text-success"></i>
												<span class="pl-2"  :class="pkg.package_type === 'Corporate' ? 'text-white' : ''">{{ details }}</span>
											</div>
										</li>
									</div>
								</ul>
								<div slot="footer" class="pb-3">
									<form @submit.prevent="upgradeHandler(pkg)">
										<b-col md="8" class="mx-auto">
											<label class="font-weight-bold">Enter Your {{ pkg.package_type }} Name:</label>
											<input class="form-control mb-3" type="text" v-model="pkg.new_corporate_name" required/>
										</b-col>
										<el-button native-type="submit" class="btn bg-fintos text-dark" :loading="is_upgrading">Upgrade Now!</el-button>
									</form>
								</div>
							</b-card>
						</b-card-group>
					</b-col>
				</b-row>
	
				<b-row class="mt-3 mt-md-6">
					<b-col cols="12">
						<b-table-simple responsive>
							<b-thead>
								<b-tr>
									<b-th>FEATURES</b-th>
									<b-th v-for="(pkg, index) in packages" :key="index" class="text-center"> {{ pkg.package_type }} Package</b-th>
								</b-tr>
							</b-thead>
							<b-tbody>
								<b-tr>
									<b-th colspan="4" class="text-center text-white" variant="dark">Dashboard Features</b-th>
								</b-tr>
								<b-tr v-for="(dashboard_feature, key) in packages[0].features.dashboard" :key="key">
									<b-td>{{ formatText(key) }}</b-td>
									<b-td v-for="(pkg, index) in packages" :key="index" class="text-center">
										<span v-if="pkg.features.dashboard[key] === true"><i class="fas fa-check text-success"></i></span>
										<span v-else-if="pkg.features.dashboard[key] === false">-</span>
										<span v-else>{{ pkg.features.dashboard[key] }}</span>
									</b-td>
								</b-tr>
	
								<b-tr>
									<b-th colspan="4" class="text-center text-white" variant="dark">CRM Features</b-th>
								</b-tr>
								<b-tr v-for="(crm_feature, key) in packages[0].features.crm_features" :key="key">
									<b-td>{{ formatText(key) }}</b-td>
									<b-td v-for="(pkg, index) in packages" :key="index" class="text-center">
										<span v-if="pkg.features.crm_features[key] === true"><i class="fas fa-check text-success"></i></span>
										<span v-else-if="pkg.features.crm_features[key] === false">-</span>
										<span v-else>{{ pkg.features.crm_features[key] }}</span>
									</b-td>
								</b-tr>
	
								<b-tr>
									<b-th colspan="4" class="text-center text-white" variant="dark">Customers List</b-th>
								</b-tr>
								<b-tr v-for="(customer_feature, key) in packages[0].features.customers_list" :key="key">
									<b-td>{{ formatText(key) }}</b-td>
									<b-td v-for="(pkg, index) in packages" :key="index" class="text-center">
										<span v-if="pkg.features.customers_list[key] === true"><i class="fas fa-check text-success"></i></span>
										<span v-else-if="pkg.features.customers_list[key] === false">-</span>
										<span v-else class="text-capitalize">{{ pkg.features.customers_list[key] }}</span>
									</b-td>
								</b-tr>
	
								<b-tr>
									<b-th colspan="4" class="text-center text-white" variant="dark">Loan Application</b-th>
								</b-tr>
								<b-tr v-for="(application, key) in packages[0].features.loan_application" :key="key">
									<b-td>{{ formatText(key) }}</b-td>
									<b-td v-for="(pkg, index) in packages" :key="index" class="text-center">
										<span v-if="pkg.features.loan_application[key] === true"><i class="fas fa-check text-success"></i></span>
										<span v-else-if="pkg.features.loan_application[key] === false">-</span>
										<span v-else class="text-capitalize">{{ pkg.features.loan_application[key] }}</span>
									</b-td>
								</b-tr>
	
								<b-tr>
									<b-th colspan="4" class="text-center text-white" variant="dark">Smart Financial Calculators</b-th>
								</b-tr>
								<b-tr v-for="(calculator, key) in packages[0].features.smart_calculators" :key="key">
									<b-td>{{ formatText(key) }}</b-td>
									<b-td v-for="(pkg, index) in packages" :key="index" class="text-center">
										<span v-if="pkg.features.smart_calculators[key] === true"><i class="fas fa-check text-success"></i></span>
										<span v-else-if="pkg.features.smart_calculators[key] === false">-</span>
										<span v-else class="text-capitalize">{{ pkg.features.smart_calculators[key] }}</span>
									</b-td>
								</b-tr>
	
								<b-tr>
									<b-th colspan="4" class="text-center text-white" variant="dark">Others</b-th>
								</b-tr>
								<b-tr>
									<b-td>Referral Link</b-td>
									<b-td v-for="(pkg, index) in packages" :key="index" class="text-center">
										<span v-if="pkg.features.referral_link" class="text-capitalize">{{ pkg.features.referral_link }}</span>
										<span v-else>-</span>
									</b-td>
								</b-tr>
							</b-tbody>
						</b-table-simple>
					</b-col>
				</b-row>
			</b-container>
			</div>
			<div class="ended" v-else>
				<div class="header mt--5 h-100 d-flex justify-content-center align-items-center">
				<b-container>
					<div class="header-body text-center mb-7">
					<b-row class="justify-content-center">
						<b-col class="px-5">
						<h1 class="display-3 text-im2u font-weight-bold mb-0">Already at BEST.</h1>
						<p class="text-im2u mb-4">You are already susbcribe to our best package.</p>
						</b-col>
					</b-row>
					</div>
				</b-container>
				<div class="separator separator-bottom separator-skew zindex-100">
					<svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
					<polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
					</svg>
				</div>
				</div>
			</div>
	  </div>
	</div>
  </template>
  <style scoped>
	.ended{
	  height: 100vh;
	}
	.text-im2u{
	  color:#252938
	}
  </style>
<script>
import { Button } from 'element-ui'
import BaseTable from "@/components/BaseTable";
import { useAuthStore } from '@/stores/authStore'
import { mapState } from 'pinia'
import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
} from '@/assets/js/httpImports.js'
export default {
	name: "pricing-page",
	components: {
		BaseTable,
		[Button.name]: Button,
	},
	mixins:[notifyFunctionMixin],
	data() {
		return {
			is_success:null,
			is_upgrading: false,
			packages: [
				// {
				// 	package_type: 'Basic',
				// 	is_disabled: false,
				// 	package_id: 1,
				// 	price: 0,
				// 	package_details: [
				// 		"Perfect for startups and small businesses.",
				// 		"Get essential features like lead management and customer tracking.",
				// 		"Monitor your leads, customers, and credit reports effortlessly.",
				// 		"Best choice for getting started with without breaking the bank."
				// 	],
				// 	features: {
				// 		dashboard: {
				// 			leads_features: true,
				// 			customer_management: true,
				// 			credit_report: true,
				// 			bank_comparison: false,
				// 			credit_score_analysis: false,
				// 			sales_performance_analytics: false,
				// 			agent_score_cards: false
				// 		},
				// 		crm_features: {
				// 			lead_management: true,
				// 			bulk_lead_uploads: false,
				// 			chat_features: false,
				// 			smart_lead_routing: false,
				// 			agent_performance_rating: false,
				// 		},
				// 		customers_list: {
				// 			purchase_fintos_report: 'RM 36',
				// 			financial_profiles_basket: false,
				// 			secure_doc_management: false
				// 		},
				// 		loan_application: {
				// 			mortgage_loan: 'Up to 5 eligible banks',
				// 			refinance: false,
				// 			property_platform_api: false,
				// 			banker_app: false
				// 		},
				// 		smart_calculators: {
				// 			legal_fees: false,
				// 			mortgage: false,
				// 		},
				// 		referral_link: false,
				// 		api_platform: ''
				// 	}
				// },
				{
					new_corporate_name: '',
					package_type: 'Corporate',
					is_disabled: false,
					package_id: 3,
					price: 4999,
					package_details: [
						"Designed for established enterprises and corporate teams.",
						"Unlock the full potential of your CRM with comprehensive features.",
						"Analyze sales performance, generate credit score analysis, and more.",
						"Refinance options, property platform API, and banker app included.",
						"Benefit from a 50% discount on purchase fintos reports."
					],
					features: {
						dashboard: {
							leads_features: true,
							customer_management: true,
							credit_report: true,
							bank_comparison: true,
							credit_score_analysis: true,
							sales_performance_analytics: true,
							agent_score_cards: true
						},
						crm_features: {
							lead_management: true,
							bulk_lead_uploads: true,
							chat_features: true,
							smart_lead_routing: true,
							agent_performance_rating: true,
						},
						customers_list: {
							purchase_fintos_report: 'discount 50%',
							financial_profiles_basket: true,
							secure_doc_management: true
						},
						loan_application: {
							mortgage_loan: 'Up to 15 eligible banks',
							refinance: true,
							property_platform_api: true,
							banker_app: true
						},
						smart_calculators: {
							legal_fees: true,
							mortgage: true,
						},
						referral_link: 'free 30 report',
						api_platform: ''
					}
				},
				{
					new_corporate_name: '',
					package_type: 'Team',
					is_disabled: false,
					package_id: 2,
					price: 1499,
					package_details: [
						"Tailored for individuals and freelancers.",
						"Access advanced tools like bulk lead uploads and chat features.",
						"Enjoy a 30% discount on purchase fintos reports.",
						"Streamline your workflow and stand out in your freelancing career."
					],
					features: {
						dashboard: {
							leads_features: true,
							customer_management: true,
							credit_report: true,
							bank_comparison: false,
							credit_score_analysis: false,
							sales_performance_analytics: false,
							agent_score_cards: false
						},
						crm_features: {
							lead_management: true,
							bulk_lead_uploads: true,
							chat_features: true,
							smart_lead_routing: false,
							agent_performance_rating: false,
						},
						customers_list: {
							purchase_fintos_report: 'discount 30%',
							financial_profiles_basket: true,
							secure_doc_management: true
						},
						loan_application: {
							mortgage_loan: 'Up to 10 eligible banks',
							refinance: true,
							property_platform_api: false,
							banker_app: false
						},
						smart_calculators: {
							legal_fees: false,
							mortgage: false,
						},
						referral_link: 'free 5 report',
						api_platform: ''
					}
				}
			]	
		};
	},
	async created(){
		await this.checkIfSuccess()
	},
	computed:{
		...mapState(useAuthStore,['auth_user']),
	},
	watch:{
		auth_user:{
			handler(newVal){
				const current_pckg_id = newVal.subscription.scrb_pckg_id

				const max_package_id = this.packages.reduce((prev, current) => (prev && prev.package_id > current.package_id) ? prev.package_id : current.package_id)
				if(current_pckg_id == max_package_id){
					this.packages = []
					return
				}
				
				this.packages.forEach((pckg, index) => {
					if(current_pckg_id >= pckg.package_id){
						this.packages.splice(index, 1)
					}
				})
			},
			immediate: true
		}
	},
	methods: {
		tryAgainHandler(){
			this.is_success = null
			this.is_upgrading = false
		},
		checkIfSuccess(){
			let payload = this.$route.query.payload
			if(!payload){
				return
			}
			let decodePayload = JSON.parse(Buffer.from(payload,'base64').toString('utf-8'));
			if(decodePayload.pay_paid_status && decodePayload.pay_paid_status.toLowerCase() === 'failed'){
				this.is_success = 0
			}
			if(decodePayload.pay_paid_status && decodePayload.pay_paid_status.toLowerCase() === 'paid'){
				this.is_success = 1
			}
		},
		formatText(str) {
			// Split the text by underscores and capitalize each word
			const words = str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1));
			
			// Join the capitalized words with a space
			return words.join(' ');
		},
		homeHandler(){
           this.$router.push('/')
        },
		upgradeHandler(pckg){
			if(!pckg.new_corporate_name){
				alert('Please enter a corporate name.')
				return
			}

			// check if user is authorize to upgrade 
			if(!this.auth_user.subscription.scrb_is_my_own){
				alert('You are not authorize to upgrade this subscription.')
				return
			}
			
			this.is_upgrading = true

			const data = {
				reg_pckg_id: pckg.package_id,
				reg_corporate_name: pckg.new_corporate_name,
				reg_callback:null,
				reg_redirect: window.location.origin + '/upgrade'
			}
           axios.post(services.billing + 'subscription/upgrade/' + this.auth_user.subscription.scrb_id, data, {headers: getHeader()})
			.then(res=>{
				const billplz_url = res.data.payment.pay_url
				window.location.href = billplz_url
			})
			.catch(e =>{
				this.is_upgrading = false
				this.errorFunction(e)
			})
		},
	}
};
</script>
  